import { EntityErrorBanner } from '@pesto/features/src/EntityProfile/components/EntityErrorBanner';
import { useListQuery } from '@pesto/hooks';
import { LoadingSpinner } from '@pesto/ui';
import { SmartTable } from '@pesto/ui/features/SmartTable/SmartTable';
import { useNavigate } from 'react-router-dom';

import { useListLoansQuery } from '../../__generated__/graphql/api';
import { routes } from '../../constants/routes';
import { useProgramFilterFields } from '../../hooks/useProgramFilterFields';
import { useLoansListConfig } from './hooks/useLoansListConfig';
import { toLoanListItem, type LoanListItem } from './toLoanListItem';

export const Loans = () => {
  const navigate = useNavigate();

  const { data, loadingOrReFetching, error } = useListQuery({
    queryHook: useListLoansQuery,
  });

  const { programFilterFields, programsLoading } = useProgramFilterFields();
  const { filterFields, getColumns, initialTableState } = useLoansListConfig(programFilterFields);

  const rows: LoanListItem[] = (data?.listLoans?.loans ?? []).map(toLoanListItem);
  const totalRecords = data?.listLoans?.pagination?.totalRecords;
  const totalPages = data?.listLoans?.pagination?.totalPages;

  const handleRowClicked = (row: LoanListItem) => {
    navigate(routes.loans + '/' + row.id);
  };

  return (
    <main className="flex flex-1 flex-col gap-4 p-4 md:p-8">
      {error && <EntityErrorBanner message="We couldn't load loans." detail={error.message} />}
      {programsLoading ? (
        <LoadingSpinner />
      ) : (
        <SmartTable
          title="Loans"
          amountOfRows={totalRecords}
          rows={rows}
          columns={getColumns(handleRowClicked)}
          filterFields={filterFields}
          loading={loadingOrReFetching}
          pageCount={totalPages}
          initialState={initialTableState}
          enableDateRangeFilter
        />
      )}
    </main>
  );
};
